export interface BuildInfo {
  productName: string;
  productVersion: string;
  buildStamp: string;
  component: string;
  environment: string;
  sourceVersion?: string | null;
  shortSha?: string | null;
  builtAtUtc?: string | null;
  displayVersion?: string | null;
}

export function normalizeBuildInfo(value: unknown): BuildInfo | null {
  if (!value || typeof value !== 'object') {
    return null;
  }

  const source = value as Record<string, unknown>;
  const data = (source['data'] ?? source['Data'] ?? source) as Record<string, unknown>;

  const productName = readString(data, 'productName', 'ProductName') || 'Solo';
  const productVersion = readString(data, 'productVersion', 'ProductVersion') || '1.0.0';
  const buildStamp = readString(data, 'buildStamp', 'BuildStamp') || 'local';
  const component = readString(data, 'component', 'Component') || 'unknown';
  const environment = readString(data, 'environment', 'Environment') || 'local';
  const sourceVersion = readString(data, 'sourceVersion', 'SourceVersion');
  const shortSha = readString(data, 'shortSha', 'ShortSha') || shortenSourceVersion(sourceVersion);
  const builtAtUtc = readString(data, 'builtAtUtc', 'BuiltAtUtc');
  const displayVersion = readString(data, 'displayVersion', 'DisplayVersion');

  return {
    productName,
    productVersion,
    buildStamp,
    component,
    environment,
    sourceVersion,
    shortSha,
    builtAtUtc,
    displayVersion
  };
}

export function formatBuildInfo(build: BuildInfo | null | undefined): string {
  if (!build) {
    return 'Solo build unknown';
  }

  return [build.productName + ' ' + build.productVersion, build.buildStamp, build.shortSha]
    .filter(value => !!value)
    .join(' • ');
}

function readString(source: Record<string, unknown>, ...keys: string[]): string | null {
  for (const key of keys) {
    const value = source[key];
    if (typeof value === 'string' && value.trim().length > 0) {
      return value.trim();
    }
  }

  return null;
}

function shortenSourceVersion(value: string | null): string | null {
  return value ? value.slice(0, 8) : null;
}
